<div class="d-flex mt-2" *ngIf="isLoading">
    <cv-loader [loaderType]="'cxone'" [size]="'large'" [overlay]="false"></cv-loader>
</div>
<sol-modal #modal class="history-modal" [title]="headerTitle" [allowClose]="true"
    (dismissed)="onDismiss()" (closed)="onClose()">
    <ng-container class="modal-content-container">
        <sol-omnibar [isFilterable]="false" [itemCountLabel]="getCombinedHistoryLabel()"
            [searchPlaceholderText]="getLocalizationString('Search_Award_History','Search')"
            [searchQuery]="filter.searchTerm" (searchQueryChange)="onSearchChange($event)" class="omnibar-container">
            <sol-omnibar-custom-content>
                <sol-date-range-picker [(ngModel)]="dateRange" [dateFormat]="dateFormat" [displayleftPanel]="true"
                    [startDOW]="0" [minDate]="minDate" [maxDate]="maxDate" [disabled]="false" [readonly]="false"
                    [type]="'range-selection'" [prevNextButtons]="false" (ngModelChange)="onDateRangeChange($event)"
                    [dateRangePresetConfigurations]="datePresetsForPicker"
                    [placeholderStartDate]="getLocalizationString('Start_Date', 'Start Date')"
                    [placeholderEndDate]="getLocalizationString('End_Date', 'End Date')"
                    class="aligned-date-picker"></sol-date-range-picker>
            </sol-omnibar-custom-content>
        </sol-omnibar>
        <div class="grid-container">
            <ag-grid-angular *ngIf="gridOptions && !shouldShowNoHistory()" [gridOptions]="gridOptions"
                [rowData]="awardHistoryList"
                class="sol-grid ag-theme-balham flex-fill border-0 d-block w-100"></ag-grid-angular>

            <!-- Error state for date range with no data -->
            <div class="error-overlay d-flex flex-column align-items-center justify-content-center"
                *ngIf="shouldShowNoHistory()">
                <svg style="width: 240px;">
                    <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
                </svg>
                <p class="cxone-empty-text" cvLocalizedText langSection="Award_History_Modal"
                    langKey="No_History_Found">No
                    history found
                </p>
            </div>
        </div>
    </ng-container>
    <sol-modal-footer>
        <div class="d-flex justify-content-end history-modal__action-buttons">
            <sol-button (click)="onClose()" variant="basic">{{closeLabel}}</sol-button>
        </div>
    </sol-modal-footer>
</sol-modal>